import { Spinner } from '@frontend/components/common';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import useVerifyCurrentLocation from './verify-current-location.controller';

const ID = 'verify-current-location';

const VerifyCurrentLocation = () => {
    const viewProps = useVerifyCurrentLocation();

    return (
        <WizardScreenContainer id={ID}>
            <div className='flex size-full items-center justify-center'>
                {viewProps.error ? <p className='text-error text-center'>{viewProps.error}</p> : <Spinner />}
            </div>
        </WizardScreenContainer>
    );
};

export default VerifyCurrentLocation;
